const NEW_CUSTOMER = 'New Customer';
const OFFER_CREATED = 'Offer Created';
const CHECKOUT = 'Checkout';
const HOME_REVIEW = 'Home Review';
const DESIGN_APPROVAL = 'Design Approval';
const CITY_PERMITTING = 'City Permitting';
const SITE_SURVEY = 'Site Survey';
const INSTALL_SCHEDULE = 'Install Schedule';
const INSTALL_SCHEDULE_CONFIRMED = 'Install Schedule Confirmed';
const CLOSED_WON = 'Closed Won';
const CLOSED_LOST = 'Closed Lost';
const INSTALL_PREP = 'Install Prep';
const INSTALLATION = 'Installation';
const CITY_INSPECTION = 'City Inspection';
const POWER_ON = 'Power On';
const ARC = 'ARC';
const UNKNOWN = 'UNKNOWN';
/**
 * Opportunity stage 1 - no appointment scheduled
 */
const OPPTY_CREATED = 'Oppty created';
/**
 * Opportunity stage 2 - appointment scheduled
 */
const APPT_SCHEDULED = 'Appt scheduled';
/**
 * Opportunity stage 3 - appointment completed
 */
const APPT_COMPLETED = 'Appt completed';
const PIPELINE_DRAWER_HOST_ID = 'pipeline-drawer-host';

type SalePhase = 'all' | 'pre-sale' | 'post-sale';

const OPPTY_STAGE_COLUMNS = [
  OPPTY_CREATED,
  APPT_SCHEDULED,
  APPT_COMPLETED,
] as const;

type OpptyStageColumn = (typeof OPPTY_STAGE_COLUMNS)[number];

const PRE_SALE_STAGES: string[] = [
  NEW_CUSTOMER,
  OFFER_CREATED,
  ...OPPTY_STAGE_COLUMNS,
  CHECKOUT,
];
const POST_SALE_STAGES = [
  HOME_REVIEW,
  DESIGN_APPROVAL,
  CITY_PERMITTING,
  INSTALL_PREP,
  INSTALLATION,
  CITY_INSPECTION,
  POWER_ON,
  ARC,
  UNKNOWN,
];

export {
  NEW_CUSTOMER,
  OFFER_CREATED,
  CHECKOUT,
  HOME_REVIEW,
  DESIGN_APPROVAL,
  CITY_PERMITTING,
  SITE_SURVEY,
  INSTALL_SCHEDULE,
  INSTALL_SCHEDULE_CONFIRMED,
  UNKNOWN,
  CLOSED_WON,
  CLOSED_LOST,
  INSTALL_PREP,
  INSTALLATION,
  CITY_INSPECTION,
  POWER_ON,
  ARC,
  OPPTY_CREATED,
  APPT_SCHEDULED,
  APPT_COMPLETED,
  OPPTY_STAGE_COLUMNS,
  PIPELINE_DRAWER_HOST_ID,
  PRE_SALE_STAGES,
  POST_SALE_STAGES,
};
export type { SalePhase, OpptyStageColumn };
